<template>
  <div class="integralRule subpage">
    <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" :is-sub-page="true" title="积分规则"></Header>
    <div class="text" v-html="this.content"></div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import { queryShopRule } from '@/api/shop'
export default {
  name: '',
  data () {
    return {
      content: ''
    }
  },
  mounted () {
    this.getData()
  },

  components: {
    Header
  },
  methods: {
    getData () {
      queryShopRule({}).then((res) => {
        this.content = res.data.content
      }).catch(_ => {
        // test
        this.content = '<p>获取积分规则失败</p>'
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.integralRule
  .text
    padding 20px
    text-align left
    line-height 0.5rem
    img
      width:100%;
</style>

<style lang="stylus">
body
  background-color #f7f7f7
</style>
